define.alias("shared/components/shared/pre-boarding/auto-trial-end/index", "preview-grid/components/shared/pre-boarding/auto-trial-end");